import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import DynamicDatatable from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";

const GeneralTaxConfiguration = ({ setAddGeneralTaxConfiguration }) => {

  const tableData = [
    { taxName: 'VAT', rate: '2%', appliesTo: 'All Products', status: 'Active' },
    { taxName: 'GST', rate: '5%', appliesTo: 'Services', status: 'Active' },
  ]

  const columns = [
    {
      name: 'Tax Name',
      selector: row => row.taxName,
    },
    {
      name: 'Rate',
      selector: row => row.rate,
    },
    {
      name: 'Applies To',
      selector: row => row.appliesTo,
    },
    {
      name: 'Status',
      selector: row => row.status,
    },
    {
      name: 'Actions',
      cell: () => <div>
        <div><button style={{ all: "unset" }}>Edit</button></div>
        <div><button style={{ all: "unset" }}>Deactivate</button></div>
      </div>
    }
  ]  

  return (
    <>
      <div className="p-3 d-flex align-items-center justify-content-between bg-white shadow rounded-top mt-3">
        <div className="fw-semibold fs-5">General Tax Configuration</div>
        <DynamicButton theme="blue" onClick={() => setAddGeneralTaxConfiguration(prev => !prev)}>
          Add New
        </DynamicButton>
      </div>

      <DynamicDatatable data={tableData} columns={columns} type='yellow' />
    </>
  );
};

export default GeneralTaxConfiguration;